import { PaginationInfo } from './pagination';

export interface WorkspacesStoreState {
	workspaces: Workspace[];
}

export interface PaginatedWorkspaces {
	workspaces: Workspace[];
	pagination: PaginationInfo;
}

export interface WorkspaceParams {
	limit?: number;
	offset?: number;
	sortBy?: string;
	query?: string;
}

export interface AddChartToWorkspacePayload {
	workspaceId: string;
	sensorId?: string;
	name?: string;
	primarySeries?: PrimarySeries;
}

export interface Workspace {
	id: string;
	name: string;
	type: string;
	description: string;
	ownerId: string;
	permission: number;
	options: string;
	status: string;
	createAt?: Date;
	createBy: string;
	modifiedAt?: Date;
	modifiedBy: string;
	workspaceItems?: WorkspaceItem[];
	activeWorkspaceItem?: WorkspaceItem;
}

export interface WorkspaceItem {
	w: number;
	h: number;
	x: number;
	name: string;
	options: WorkspaceItemOptions;
	i: string;
	y: number;
	type: string;
}

export interface WorkspaceItemOptions {
	primarySeries: PrimarySeries;
	displayOptions: WorkspaceItemDisplayOptions;
}

export interface SimulationPrimarySeries {
	analysisGroupId: string;
	attribute: string;
	databaseId: string;
	objectId: string;
	resultId: string;
	tableId: string;
}

export interface WorkspaceItemDisplayOptions {
	overlay?: boolean;
	showYGrid?: boolean;
	showXGrid?: boolean;
}

export interface PrimarySeries {
	alias: string;
	unit: string;
	id: string;
	func: string;
	resolution: string;
	displayOptions: PrimarySeriesDisplayOptions;
	dataOverride?: [number, number][];
	uniqueId?: string;
	params?: Record<string, unknown>;
	minTimestamp?: number;
	seriesDataType?: 'measured' | 'forecast';
	separateYAxisId?: string | undefined;
	collectionInterval?: number;
	maxTimestamp?: number;
	simulation?: SimulationPrimarySeries;
}

export interface PrimarySeriesDisplayOptions {
	chartType?: string;
}
